'use client';

import dynamic from 'next/dynamic';

import styles from './styles.module.css';
import CabecalhoHomeFallback from '@/components/organisms/CabecalhoHome/fallback';
import CabecalhoComBotaoVoltarFallback from '@/components/organisms/CabecalhoComBotaoVoltar/fallback';
import CabecalhoLogarFallback from '@/components/organisms/CabecalhoLogar/fallback';
import { usePathname } from 'next/navigation';
import estaNoContextoHome from '@/utils/verificarCaminhoURL';
import Dialog from '@/components/molecules/Dialog';
import { Fragment, useState } from 'react';
import ListagemItensBusca from '@/components/organisms/ListagemItensBusca';
import useBreakpoint from '@/hooks/useBreakpoint';
import { registrarEvento } from '@/services/googleAnalytics';

const CabecalhoHome = dynamic(
  () => import('@/components/organisms/CabecalhoHome'),
  {
    ssr: false,
    loading: () => <CabecalhoHomeFallback $color="accent" $variant="solid" />,
  },
);

const CabecalhoComBotaoVoltar = dynamic(
  () => import('@/components/organisms/CabecalhoComBotaoVoltar'),
  {
    ssr: false,
    loading: () => (
      <CabecalhoComBotaoVoltarFallback $color="accent" $variant="solid" />
    ),
  },
);

const CabecalhoLogar = dynamic(
  () => import('@/components/organisms/CabecalhoLogar'),
  {
    ssr: false,
    loading: () => <CabecalhoLogarFallback $color="accent" $variant="solid" />,
  },
);

export default function CabecalhoTemplate() {
  const caminhoURL = usePathname();
  const { breakpoint } = useBreakpoint();

  const [inputAtivo, setInputAtivo] = useState(false);
  const [valorBusca, setValorBusca] = useState('');

  return (
    <Fragment>
      <div className={styles.fixacao}>
        <div className={styles.background} />
        {!(
          caminhoURL.includes('/cadastrar-novo-cartao') &&
          breakpoint === 'mobile'
        ) &&
        estaNoContextoHome(caminhoURL) &&
        !caminhoURL.includes('/refazer-pedido') ? (
          <CabecalhoHome
            $color="accent"
            $variant="solid"
            $valorInputPesquisa={valorBusca}
            $setarValorInputPesquisa={setValorBusca}
            $setarInputAtivo={(estado) => {
              setInputAtivo(estado);
              if (estado === true) {
                registrarEvento('clicou_busca', {});
              }
            }}
          />
        ) : (
          <Fragment></Fragment>
        )}
        {['/logar', '/complementar-cadastro'].includes(caminhoURL) ? (
          <CabecalhoLogar $color="accent" $variant="solid" />
        ) : (
          <Fragment></Fragment>
        )}
        {caminhoURL.includes('/refazer-pedido') ||
        caminhoURL.includes('/customizar-plano') ||
        (caminhoURL.includes('/cadastrar-novo-cartao') &&
          breakpoint === 'mobile') ||
        (!estaNoContextoHome(caminhoURL) &&
          !['/logar', '/complementar-cadastro'].includes(caminhoURL)) ? (
          <CabecalhoComBotaoVoltar $color="accent" $variant="solid" />
        ) : (
          <Fragment></Fragment>
        )}
      </div>
      <Dialog open={inputAtivo || !!valorBusca.length}>
        {valorBusca.length >= 1 ? (
          <ListagemItensBusca
            $termoBusca={valorBusca}
            $funcaoAdicional={() => {
              setInputAtivo(false);
              setValorBusca('');
            }}
          />
        ) : (
          <Fragment></Fragment>
        )}
      </Dialog>
    </Fragment>
  );
}
